import {Component, Input} from '@angular/core';
import {FirebaseService} from '../../../../shared-utilities/services-old/firebase.service';
import {StockValChangeCheckConfig} from '../../../../shared-utilities/models-old/datastructures';
import {StoreObject} from '../../../../shared-utilities/models-old/store/store-object';
import {
  CollectionStoresSettingsService
} from '../../../../shared/shared-services/firebase/collection-stores-settings.service';
import {ISelectOption} from '../../../../shared/shared-models/custom-select/custom-select';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';
import {SharedModalUtils} from '../../../../shared/shared-utils/shared-modal/shared-modal.utils';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';
import {IconColourEnum} from '../../../shared-icons/models/icons-colour.enum';
import {
  presentSharedOverlayLoadingModal,
} from '../../../../shared/shared-components/components/shared-overlay-loading-modal/shared-overlay-loading-modal.component';

interface ThresholdSettings {
  neg: number;
  pos: number;
}

@Component({
  selector: 'app-price-threshold',
  templateUrl: './price-threshold.component.html',
  styleUrls: ['./price-threshold.component.scss'],
  standalone: false
})
export class PriceThresholdComponent {
  @Input() stores?: StoreObject;

  selectedStore: string;
  // TODO: make this StockValChangeCheckConfig;
  thresholds: Record<string, ThresholdSettings> = {};

  constructor(
    private firebaseService: FirebaseService,
    private collectionStoresSettingsService: CollectionStoresSettingsService,
    private readonly modalController: ModalControllerService,
    private readonly sharedModalUtils: SharedModalUtils,
  ) {
  }

  storeSelectOptions(): Record<string, ISelectOption> {
    if (!this.stores?.order) {
      return {};
    }

    const options: Record<string, ISelectOption> = {};
    this.stores.order.forEach((storeId: string) => {
      options[storeId] = {
        name: this.stores.stores[storeId].name,
        selected: this.selectedStore === storeId,
        disabled: false,
      };
    });
    return options;
  }

  onStoreSelectionChange(selected: Record<string, ISelectOption>): void {
    const storeId: string | undefined = Object.keys(selected).find((key: string) => selected[key].selected);
    if (!storeId) {
      return;
    }

    this.selectedStore = storeId;
    void this.onChangeStoreSelect();
  }

  async onChangeStoreSelect(): Promise<void> {
    if (this.thresholds[this.selectedStore]) {
      return;
    }

    this.thresholds[this.selectedStore] = {neg: 0.2, pos: 0.2};
    const loadingModal = await presentSharedOverlayLoadingModal(this.modalController, 'Fetching settings…');
    try {
      const thresh = await this.firebaseService.getStoreEditFlagConfig(this.selectedStore);

      if (thresh.sellPriIncl1) {
        this.thresholds[this.selectedStore] = {pos: thresh.sellPriIncl1.pct, neg: thresh.sellPriIncl1.negPct};
      }
    } finally {
      await loadingModal.dismiss();
    }
  }

  onValueChange(storeId: string, valueEvent: Event, valueKey: keyof ThresholdSettings): void {
    const event = valueEvent as CustomEvent<{value: number}>;
    if (event.detail.value >= 100) {
      this.thresholds[storeId][valueKey] = 1;
    } else if (event.detail.value <= 0) {
      this.thresholds[storeId][valueKey] = 0;
    } else {
      this.thresholds[storeId][valueKey] = event.detail.value / 100;
    }
  }

  async onClickSave(event: Event): Promise<void> {
    (event.target as HTMLInputElement).disabled = true;
    const config: StockValChangeCheckConfig = {
      sellPriIncl1: {
        pct: this.thresholds[this.selectedStore].pos,
        negPct: this.thresholds[this.selectedStore].neg
      }
    };

    await this.collectionStoresSettingsService.setDocument<StockValChangeCheckConfig>('stock_edit_thresholds', config);
    await this.sharedModalUtils.createModal({
      modalTitle: 'Thresholds Set',
      modalTitleIcon: IconsEnum.checkCircle,
      modalTitleIconColor: IconColourEnum.green,
      contextDescription: [
        `The price change thresholds for ${this.stores.stores[this.selectedStore].name} have been updated.`,
      ],
      buttonAcceptText: 'OK',
      buttonCloseText: '',
      buttonAccept: true,
      buttonClose: false,
      buttonCloseCross: false,
      cssClass: ['shared-basic-modal-css-smaller'],
    });
    (event.target as HTMLInputElement).disabled = false;
  }
}
